import { useState } from "react";
import { DOCS } from "../../lib/docs";
import { aandachtspunten } from "../../lib/data";
import { DocReader } from "./DocReader";
import { KaartenGrid } from "./Kaarten";
import { Contacten } from "./Contacten";
import { Bandjes } from "./Bandjes";
import { AandachtspuntenlijstView } from "./AandachtspuntenlijstView";

export function DocsHub() {
  const [openId, setOpenId] = useState<string | null>(null);
  const open = openId ? DOCS.find((d) => d.id === openId) : null;

  if (open && !open.external) {
    if (open.kind === "excel") {
      return <AandachtspuntenlijstView onBack={() => setOpenId(null)} />;
    }
    return <DocReader doc={open} onBack={() => setOpenId(null)} />;
  }

  return (
    <div className="space-y-2">
      <h3 className="eyebrow px-1">Bandjes — geldig vandaag</h3>
      <Bandjes />
      <h3 className="eyebrow px-1 pt-3">Contacten</h3>
      <Contacten />
      <h3 className="eyebrow px-1 pt-3">Kaarten</h3>
      <KaartenGrid />
      <h3 className="eyebrow px-1 pt-3">Documenten</h3>
      <p className="text-2xs text-zinc-500 px-1 mb-2">
        {DOCS.length} bronnen — klik een tegel om te lezen of te zoeken in de
        originele documentatie.
      </p>
      <ul className="space-y-2">
        {DOCS.map((d) => {
          const highlightCount = aandachtspunten.filter(
            (a) => a.source.label === d.highlightSourceLabel,
          ).length;

          const cardInner = (
            <div className="flex items-start gap-3">
              <DocIcon kind={d.kind} />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-semibold text-zinc-100">{d.title}</span>
                  <span className="pill bg-ink-800 text-zinc-500 border border-white/[0.04]">
                    {d.kind === "excel" ? "XLSX" : "PDF"}
                  </span>
                  {d.external && (
                    <span className="pill bg-accent/10 text-accent border border-accent/22">
                      EXTERN
                    </span>
                  )}
                </div>
                <div className="text-2xs text-zinc-500 mt-0.5 truncate">
                  {d.subtitle}
                </div>
                <div className="text-2xs text-zinc-600 mt-1 tabular flex items-center gap-2">
                  {d.pages && <span>{d.pages}p</span>}
                  {d.pages && <span>·</span>}
                  <span>
                    {d.sizeMb < 1
                      ? `${Math.round(d.sizeMb * 1000)} KB`
                      : `${d.sizeMb} MB`}
                  </span>
                  {highlightCount > 0 && (
                    <>
                      <span>·</span>
                      <span className="text-warn">
                        {highlightCount} aandachtspunten
                      </span>
                    </>
                  )}
                </div>
              </div>
              <span className="text-zinc-600 self-center">
                {d.external ? "↗" : "›"}
              </span>
            </div>
          );

          return (
            <li key={d.id}>
              {d.external ? (
                <a
                  href={d.filePath}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full card p-3 text-left hover:bg-ink-800 transition-colors no-scale"
                >
                  {cardInner}
                </a>
              ) : (
                <button
                  onClick={() => setOpenId(d.id)}
                  className="w-full card p-3 text-left active:bg-ink-700/40 hover:bg-ink-800 transition-colors no-scale"
                >
                  {cardInner}
                </button>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}

function DocIcon({ kind }: { kind: "excel" | "pdf" }) {
  const cls =
    kind === "excel"
      ? "bg-ok/10 text-ok"
      : "bg-accent/10 text-accent";
  return (
    <div
      className={`shrink-0 w-10 h-10 rounded-lg flex items-center justify-center font-mono text-2xs font-semibold tracking-wide ${cls}`}
      style={{ border: "1px solid rgba(255,255,255,0.04)" }}
    >
      {kind === "excel" ? "XLS" : "PDF"}
    </div>
  );
}
